import {DisplayUrl, MessageProcData, ProcBaseData, ProcData} from 'priority-web-sdk';
import {showErrorMessage, showInfoMessage} from '../../../_shared/Messages/actions/MessageActions';
import {startProcedure} from '../../../services/webSdk/service';

export const journalEntriesCheckProc = async (): Promise<string> => {
    return await runJournalsProcedure('CHKFNCTRANS');
};

export const runJournalsProcedure = async (procName: string): Promise<any> => {
    const procRes: ProcData = await startProcedure(procName, 'P');
    return processProcStepResult(procRes);
};

export const processProcStepResult = async (procRes: ProcData) => {
    return new Promise(async (resolve, reject) => {
        const proc = procRes.proc;
        switch (procRes.type) {
            case 'message':
                const msgRes = procRes as ProcBaseData & MessageProcData;
                if (msgRes.messagetype === 'information') {
                    showInfoMessage({content: msgRes.message});
                } else if (msgRes.messagetype === 'warning') {
                    const res = await proc.continueProc();
                    resolve(processProcStepResult(res));
                } else if (msgRes.messagetype === 'error') {
                    showErrorMessage({title: msgRes.message, onConfirm: () => reject()});
                }
                break;
            case 'reportOptions':
                const reportOptionsRes = await proc.reportOptions(1, -1);
                resolve(processProcStepResult(reportOptionsRes));
                break;
            case 'displayUrl':
                const displayUrlRes = procRes as ProcBaseData & DisplayUrl;
                const url = displayUrlRes.Urls?.[0].url;
                window.open(url, '_blank');
                resolve(url);
                break;
            default:
                break;
        }
    });
};
